/**
 * Directive: sum
 */
angular.module('acme.common.directive.sum', [
  'acme.common.directive.numeric'
])
.directive('sum', [function() {

    return {
      restrict: 'A',
      replace: true,
      templateUrl: 'common/directives/sum/sum.tpl.html',
      scope: {
        min: '@',
        max: '@',
        cost: '@',
        total: '=',
        quantity: '=',
        remaining: '=',
        labelledby: '@',
        groups: '=?',
        updateAction: '&',
        hideActions: '@',
        disableActions: '@',
        limit: '@',
        groupQuantity: '@'
      },

      link: function($scope, $element, $attrs) {
        // Modified after controller runs
      },

      controller: ['$scope', '$timeout', function($scope, $timeout) {

        $scope.sum = {

          total: 0,
          min: 0,
          max: 0,
          quantityWatcher: {},
          groupsWatcher: {},
          maxWatcher: {},
          disableAdd: false,
          disableSubtract: false,
          isMaxed: false,
          isDirty: false,
          labelledby: '',
          groups: [],
          hideActions: false,
          disableActions: true,

          updateTimer: false,

          init: function() {
            this.quantityWatcher = $scope.$watch('quantity', this.onQuantityUpdate);
            this.groupsWatcher = $scope.$watch('groups', this.onGroupsUpdate);
            this.maxWatcher = $scope.$watch('max', this.onMaxUpdate);
            this.labelledby = $scope.labelledby;

            if (!$scope.quantity && $scope.min) {
              $scope.quantity = +$scope.min;
            }

            if ($scope.hideActions && ($scope.hideActions === "true" || $scope.hideActions === true)) {
              this.hideActions = true;
            }

            if ($scope.disableActions) {
              this.disableActions = ($scope.disableActions === "false") ? false : true;
            }

            $scope.$on('Event::selectHour', this.onEventSelectHour);
            $scope.$on('Event::selectComboHour', this.onEventSelectHour);
            $scope.$on('Event::updatedLimits', this.onEventUpdatedLimits);

            $scope.$on('destroy', function() {
              var self = $scope.sum;
              $timeout.cancel(self.updateTimer);
            });

            this.checkRemaining();
          },

          add: function() {
            this.isDirty = true;
            this.checkRemaining();

            if (this.disableAdd === false) {
              if ($scope.max) {
                if (!this.disableActions) {
                  $scope.quantity = +$scope.quantity + 1;
                } else {
                  $scope.quantity = (+$scope.quantity + 1 <= $scope.max) ? +$scope.quantity + 1 : +$scope.max;
                }
              } else {
                $scope.quantity = +$scope.quantity + 1;
              }
            }

          },

          subtract: function() {
            this.isDirty = true;
            this.checkRemaining();

            if (this.disableSubtract === false) {
              if ($scope.min) {
                $scope.quantity = (+$scope.quantity - 1 >= $scope.min) ? +$scope.quantity - 1 : +$scope.min;
              } else {
                $scope.quantity = (+$scope.quantity - 1 >= 0) ? +$scope.quantity - 1 : 0;
              }
            }

          },

          checkRemaining: function() {
            var i, ii;

            this.disableAdd = false;
            this.isMaxed = false;


            //First check capacity for the event
            if ($scope.remaining < 1) {
              this.disableAdd = true;
              this.isMaxed = true;

              // Remove negative remaining seats from quantity if it is exceeded
              if ($scope.quantity > Math.abs($scope.remaining)) {
                $scope.quantity -= Math.abs($scope.remaining);
                $scope.remaining = 1;
              }else{
                this.isMaxed = false;
                $scope.quantity = 0;
                $scope.remaining = 0;
              }
            }

            //then check rules
            if ($scope.groups instanceof Array && $scope.groups.length) {
              // groupMax - groupQuantity is the max
              for (i=0, ii=$scope.groups.length; i < ii; i++) {
                if (!this.isMaxed && ($scope.groups[i].groupQuantity > $scope.groups[i].groupMax)) {
                  this.isMaxed = ($scope.groups[i].groupQuantity > $scope.groups[i].groupMax);

                  if ($scope.groups[i].isPreventRule && this.isMaxed) {
                    this.isMaxed = ($scope.groups[i].preventGroupQuantity > 0);
                  }
                }

                if ($scope.groups[i].isPreventRule && !$scope.groups[i].inCartLimit) {
                  this.isMaxed = ($scope.groups[i].preventGroupQuantity > 0);
                }

                if (!this.disableAdd && ($scope.groups[i].groupQuantity >= $scope.groups[i].groupMax)) {
                  this.disableAdd = ($scope.groups[i].groupQuantity >= $scope.groups[i].groupMax);
                }
              }
            }

            // no $scope.groups but we have group quantity and limits
            if (
              $scope.limit && $scope.groupQuantity && !$scope.max &&
              (parseInt($scope.groupQuantity,10) > parseInt($scope.limit,10))
            ) {
              this.isMaxed = true;
            }

            //then check max
            if ($scope.max) {
              if ($scope.quantity > Math.abs($scope.max)) {
                  this.isMaxed = true;
              }

              if ($scope.quantity >= Math.abs($scope.max)) {
                this.disableAdd = true;
              }
            }

            if (!this.disableActions) {
              this.disableAdd = false;
            }
          },

          checkGroupMax: function() {

            if ($scope.remaining < 1) {
              this.disableAdd = true;
              this.isMaxed = true;

              // Remove negative remaining seats from quantity if it is exceeded
              if ($scope.quantity > Math.abs($scope.remaining)) {
                $scope.quantity -= Math.abs($scope.remaining);
                $scope.remaining = 1;
              }else{
                this.isMaxed = false;
                $scope.quantity = 0;
                $scope.remaining = 0;
              }
            } else if ($scope.max) {
              this.isMaxed = ($scope.quantity > Math.abs($scope.max));
              this.disableAdd = ($scope.quantity >= Math.abs($scope.max));
            } else{
              this.disableAdd = false;
              this.isMaxed = false;
            }
          },

          updateTotal: function() {
            $scope.total = this.getTotal();

            if (this.updateTimer) {
              $timeout.cancel(this.updateTimer);
            }

            this.updateTimer = $timeout(function() {
              $scope.$emit('Sum::UpdateTotal');
              if (typeof $scope.updateAction === 'function') {
                $scope.updateAction();
              }
            }, 1100);
          },

          getTotal: function() {
            return ($scope.quantity * parseInt((+$scope.cost * 100), 10) / 100);
          },

          onDestroy: function() {
            $scope.sum.quantityWatcher();
            $scope.sum.groupsWatcher();
          },

          onEventSelectHour: function() {
            $scope.sum.onQuantityUpdate();

            if ($scope.quantity >= Math.abs($scope.remaining)) {
              $scope.quantity = Math.abs($scope.remaining);
              $scope.remaining = 0;
            }
          },

          onEventUpdatedLimits: function() {
            $scope.sum.checkRemaining();
          },

          onQuantityUpdate: function() {
            $scope.sum.updateTotal();
            if ($scope.sum.isDirty) {
              $scope.sum.checkRemaining();
            }
          },

          onGroupsUpdate: function(newValue, oldValue) {
            if (newValue !== oldValue) {
              $scope.sum.checkRemaining();
            }
          },

          onMaxUpdate: function(newValue, oldValue) {
            if (newValue !== oldValue) {
              $scope.sum.checkRemaining();
            }
          }

        };

        $scope.sum.init();

      }]

    };

}]);
